module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    class: {
      'nav-extended': _vm.navs
    }
  }, [_c('div', {
    staticClass: "nav-wrapper container"
  }, [_c('router-link', {
    staticClass: "brand-logo",
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_vm._v("SPYC Library")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "right hide-on-med-and-down"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'intro',
        params: {
          section: 'aim'
        }
      }
    }
  }, [_vm._v("\n                    Introduction\n                ")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'books'
      }
    }
  }, [_vm._v("\n                    Book Recommend\n                ")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'booklist'
      }
    }
  }, [_vm._v("\n                    Book List\n                ")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'service',
        params: {
          section: 'loan'
        }
      }
    }
  }, [_vm._v("\n                    Service\n                ")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'librarian',
        params: {
          section: 'members'
        }
      }
    }
  }, [_vm._v("\n                    Librarian\n                ")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'purchase'
      }
    }
  }, [_vm._v("\n                    Suggestion\n                ")])], 1)]), _vm._v(" "), _c('ul', {
    staticClass: "side-nav",
    attrs: {
      "id": "side-nav"
    }
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("home")]), _vm._v("\n                    Home\n                ")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'books'
      }
    }
  }, [_vm._v("\n                    Book Recommend\n                ")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'booklist'
      }
    }
  }, [_vm._v("\n                    Book List\n                ")])], 1), _vm._v(" "), _c('li', {
    staticClass: "no-padding"
  }, [_c('ul', {
    staticClass: "collapsible collapsible-accordion"
  }, [_c('li', [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "collapsible-body"
  }, [_c('ul', _vm._l((_vm.nav.intro), function(link) {
    return _c('li', [_c('router-link', {
      attrs: {
        "to": {
          name: 'intro',
          params: {
            section: link.section
          }
        }
      }
    }, [_vm._v("\n                                        " + _vm._s(link.display) + "\n                                    ")])], 1)
  }))])]), _vm._v(" "), _c('li', [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "collapsible-body"
  }, [_c('ul', _vm._l((_vm.nav.service), function(link) {
    return _c('li', [_c('router-link', {
      attrs: {
        "to": {
          name: 'service',
          params: {
            section: link.section
          }
        }
      }
    }, [_vm._v("\n                                        " + _vm._s(link.display) + "\n                                    ")])], 1)
  }))])]), _vm._v(" "), _c('li', [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "collapsible-body"
  }, [_c('ul', _vm._l((_vm.nav.librarian), function(link) {
    return _c('li', [_c('router-link', {
      attrs: {
        "to": {
          name: 'librarian',
          params: {
            section: link.section
          }
        }
      }
    }, [_vm._v("\n                                        " + _vm._s(link.display) + "\n                                    ")])], 1)
  }))])]), _vm._v(" "), _c('li', [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "collapsible-body"
  }, [_c('ul', _vm._l((_vm.nav.suggestion), function(link) {
    return _c('li', [_c('router-link', {
      attrs: {
        "to": {
          name: link.name
        }
      }
    }, [_vm._v("\n                                        " + _vm._s(link.display) + "\n                                    ")])], 1)
  }))])])])])]), _vm._v(" "), (_vm.navs) ? _c('ul', {
    staticClass: "nav-tabs tabs-transparent hide-on-med-and-down"
  }, _vm._l((_vm.navs), function(nav) {
    return _c('li', {
      staticClass: "tab"
    }, [('name' in nav) ? _c('router-link', {
      attrs: {
        "active-class": "active",
        "to": {
          name: nav.name
        }
      }
    }, [_vm._v("\n                    " + _vm._s(nav.display) + "\n                ")]) : _vm._e(), _vm._v(" "), ('section' in nav) ? _c('router-link', {
      attrs: {
        "active-class": "active",
        "to": {
          name: _vm.name,
          params: {
            section: nav.section
          }
        }
      }
    }, [_vm._v("\n                    " + _vm._s(nav.display) + "\n                ")]) : _vm._e()], 1)
  })) : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "button-collapse",
    attrs: {
      "href": "#",
      "data-activates": "side-nav"
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("menu")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "collapsible-header"
  }, [_vm._v("Introduction "), _c('i', {
    staticClass: "material-icons"
  }, [_vm._v("arrow_drop_down")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "collapsible-header"
  }, [_vm._v("Service "), _c('i', {
    staticClass: "material-icons"
  }, [_vm._v("arrow_drop_down")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "collapsible-header"
  }, [_vm._v("Librarian "), _c('i', {
    staticClass: "material-icons"
  }, [_vm._v("arrow_drop_down")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "collapsible-header"
  }, [_vm._v("Suggestion "), _c('i', {
    staticClass: "material-icons"
  }, [_vm._v("arrow_drop_down")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-568a4039!./~/vue-loader/lib/selector.js?type=template&index=0!./assets/js/component/Navbar.vue
// module id = 78
// module chunks = 0